<div class="heading_wrapper d-flex justify-content-between align-items-baseline">
  <div>
    <h2 class="h2">
      Notifications
    </h2>
  </div>
</div>
<p class="mt-2">
  Please review your notifications.
</p>

<div class="user_dashboard_hero mb-5">
  <!-- Recent Activity -->
  <div class="recent_activity mb-5">
    <div class="recent_activity_list">
      @if (notificationsData.data.length > 0) {
        <div class="activity_table table-responsive"
          >
          <table class="table" aria-describedby="tableHeading">
            <thead>
              <tr>
                <th scope="col">Date</th>
                <th scope="col">Time</th>
                <th scope="col">Notification Message</th>
              </tr>
            </thead>
            <tbody>
              @for (notification of notificationsData.data.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage); track notification) {
                <tr
                  >
                  <td>{{ getConvertedDate(notification.createDate) | date:'mediumDate'}}</td>
                  <td>{{ getConvertedDate(notification.createDate) | date:'shortTime'}}</td>
                  <td>{{ notification.notificationMss }}</td>
                </tr>
              }
            </tbody>
          </table>
          <!-- If no activity, Show this -->
        </div>
      } @else {
        <div class="activity_list_body no_activity">
          <div class="single_activity">
            <div class="activity_date_time">You do not have any Notifications.</div>
          </div>
        </div>
      }

      <!-- Pagination  -->
      <div class="fc_pagination d-flex flex-wrap justify-content-between align-items-center my-3">
        <div class="showed_page">Page {{currentPage}} of {{getTotalPages()}}</div>
        <ul class="pagination justify-content-end">
          <li class="page-item" (click)="onPageChange(currentPage - 1)" [class.disabled]="currentPage === 1">
            <a class="page-link">Previous</a>
          </li>
          <li class="page-item" (click)="onPageChange(currentPage + 1)"
            [class.disabled]="currentPage === getTotalPages()">
            <a class="page-link">Next</a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>